import React, { useCallback, useState } from "react"

import { type LeadWorkspacePatch } from "../../../Lead/LeadWorkspacePage/lead-workspace-patch.ts"
import { LeadScopeTab } from "../../../Lead/LeadWorkspacePage/scope/LeadScopeTab.tsx"
import { type Lead } from "../../../Lead/types/lead.types.ts"
import {
  TOUR_DEMO_LEAD_FILTER_OPTIONS,
  TOUR_DEMO_LEAD_RECORD
} from "../../content/tour-demo-data.ts"

/**
 * The REAL Lead Scope tab (`LeadScopeTab`, presentational), same demo-state
 * pattern as `DemoLeadOverviewSection.tsx`.
 */
export const DemoLeadScopeSection = () => {
  const [lead, setLead] = useState<Lead>(TOUR_DEMO_LEAD_RECORD)

  const onPatch = useCallback(async (patch: LeadWorkspacePatch) => {
    setLead((prev) => ({ ...prev, ...patch }) as Lead)
    return true
  }, [])

  return (
    <LeadScopeTab
      lead={lead}
      canEdit
      filterOptions={TOUR_DEMO_LEAD_FILTER_OPTIONS}
      onPatch={onPatch}
    />
  )
}
